import http from '@/http'
const URL = '/admin/settings/tasks/flight-block'

export const list = async (params) => {
  return http.get(URL, { params: params })
}

export const listContacts = async (obj) => {
  return http.get(URL + `/${obj.id}/contacts`, { params: obj.params })
}

export const show = async (id) => {
  if (!id) return null
  return http.get(URL + `/${id}`)
}

export const save = (payload) => {
  return http.post(URL, payload)
}

export const countParticipants = (payload) => {
  return http.post('/admin/settings/tasks/count-participants', payload)
}

export default {
  list,
  listContacts,
  show,
  save,
  countParticipants
}
